module.exports = __webpack_public_path__ + "static/img/ca5s1bg.d1760dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ca5s1bg.jpg
// module id = yL56
// module chunks = 1